import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMutation } from "urql";
import { auth } from "../firebase";
import PasswordSet from "../components/PasswordSet"
import { useFinishUserRegistrationMutation } from "../gql/generated-hooks";
import { ROUTES } from "../routes";
import { validateUUID } from "../utils/validation";
import { useNotification } from "../hooks/useNotification";
import Notification from "../components/Notification";

export default function CompleteSignUp() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [userRegistrationResult, executeFinishUserRegistration] = useFinishUserRegistrationMutation();
  const { notifications, removeNotification, showError, showSuccess } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const handleCompleteClick = async (password: string) => {
    if (!userId || !validateUUID(userId)) {
      showError("Invalid registration link. Please check your email for the correct link.");
      return;
    }

    setIsLoading(true);
    
    try {
      const result = await executeFinishUserRegistration({
        id: userId,
        password: password 
      });

      if (result.error) {
        showError("Registration failed: " + result.error.message);
        return;
      }

      showSuccess("Registration completed successfully! You can now log in.");
      setTimeout(() => {
        navigate(ROUTES.LOGIN);
      }, 2000);
      
    } catch (error) {
      console.error("Error completing registration:", error);
      showError("Registration failed. Please try again or contact support.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!userId) {
      showError("Invalid registration link.");
      return;
    }
    
    if (!validateUUID(userId)) {
      showError("Invalid user ID format. Please check your registration link.");
      return;
    }
  }, [userId, showError]);

  return (
    <div className="login-container">
      <h1>Welcome to GDS Archive</h1>
      <p>Complete sign up by creating a password for your account</p>
      
      {userId && validateUUID(userId) ? (
        <PasswordSet 
          confirmButtonText={isLoading ? "Processing..." : "Complete sign up"} 
          onConfirm={handleCompleteClick}
        />
      ) : (
        <div style={{ color: 'red', textAlign: 'center' }}>
          Invalid registration link. Please check your email for the correct link.
        </div>
      )}

      {/* Render notifications */}
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          message={notification.message}
          type={notification.type}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  );
}
